 export const config = {
    year: {
        caption: {
            text: 'سال',
        },
    },
    month: {
        caption: {
            text: 'ماه',
        },
    },
    day: {
        caption: {
            text: 'روز',
        },
    },
};

 